import { render, staticRenderFns } from "./ChangeForgotPassword.vue?vue&type=template&id=cd2954c0&"
import script from "./ChangeForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ChangeForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports